<template>
  <div class="flex flex-col flex-1 p-5">
    <div class="flex items-center justify-between gap-4 mb-3">
      <span class="font-medium text-gray-800">
        {{ $t("skills.manage_skill.info.title") }}
      </span>
      <InputText
        v-model="search"
        class="w-full"
        style="max-width: 320px"
        :placeholder="$t('skills.manage_skill.info.search')"
      />
    </div>
    <div class="flex-1 overflow-auto">
      <DataTable
        :value="filteredSkills"
        :loading="loading"
        paginator
        :rows="10"
        :alwaysShowPaginator="false"
      >
        <template #empty>
          <p class="text-primary-900 text-sm text-center">
            {{ $t("skills.manage_skill.info.empty") }}
          </p>
        </template>
        <Column
          header-class="bg-primary-900 text-white text-center font-medium rounded-s-lg text-xs"
          body-class="text-sm text-center"
          :header="$t('skills.manage_skill.info.info_name')"
        >
          <template #body="{ data }">
            {{ $i18n.locale === "ar" ? data.titles?.ar : data.titles?.en }}
          </template>
        </Column>
        <Column
          field="name"
          header-class="bg-primary-900 text-white text-center font-medium text-xs"
          body-class="text-sm text-center"
          :header="$t('skills.manage_skill.info.short_code')"
        ></Column>
        <Column
          field="agentsCount"
          header-class="bg-primary-900 text-white text-center font-medium text-xs"
          body-class="text-sm text-center"
          :header="$t('skills.manage_skill.info.info_agents')"
        ></Column>
        <Column
          field="calls"
          header-class="bg-primary-900 text-white text-center font-medium text-xs"
          body-class="text-sm text-center"
          :header="$t('skills.manage_skill.info.info_calls')"
        ></Column>
        <Column
          field="busy"
          header-class="bg-primary-900 text-white text-center font-medium text-xs"
          body-class="text-sm text-center"
          :header="$t('skills.manage_skill.info.info_limit_agent')"
        ></Column>
        <Column
          field="rest"
          header-class="bg-primary-900 text-white text-center font-medium text-xs"
          body-class="text-sm text-center"
          :header="$t('skills.manage_skill.info.info_limit_rest')"
        ></Column>
        <Column
          header-class="bg-primary-900 text-white text-center font-medium rounded-e-lg text-xs"
          body-class="text-sm text-center"
          header-style="width: 110px"
          :header="$t('skills.manage_skill.info.actions')"
        >
          <template #body="{ data }">
            <Button
              icon="mdi mdi-cog-outline"
              text
              rounded
              severity="secondary"
              :aria-label="$t('skills.manage_skill.config.configure_btn')"
              @click="showQueueConfig(data)"
            />
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { DataTable, Column, InputText, Button } from "primevue";
export default {
  components: {
    DataTable,
    Column,
    InputText,
    Button,
  },
  data() {
    return {
      skillsInfo: [],
      search: "",
      loading: false,
    };
  },

  methods: {
    ...mapActions([
      "GetSkillInfo",
      "SetForwarding",
      "SetMessageDialog",
      "ShowProgressBar",
      "GetDomainSkills",
    ]),

    async doSetForwarding() {
      try {
        var resp = await this.SetForwarding({
          skill: this.$route.params.skill,
          enabled: !this.skillInfo.callForwarding,
        });
        this.ShowProgressBar({ show: false, message: "" });
        if (!resp.success) {
          this.SetMessageDialog({ show: true, message: resp.message });
        } else {
          this.SetMessageDialog({
            show: true,
            message: resp.message,
            success: resp.success,
          });
          await this.GetSkillInfo(this.$route.params.skill);
        }
      } catch (err) {
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.ShowProgressBar({ show: false, message: "" });
        this.SetMessageDialog({ show: true, message: message });
      }
    },
    async initManageSkill() {
      const skills = [];
      this.loading = true;
      try {
        for (const skill of this.domainSkills) {
          await this.GetSkillInfo(skill.name);
          skills.push({ ...this.skillInfo, titles: skill.titles });
        }
        this.skillsInfo = skills;
      } finally {
        this.loading = false;
      }
    },
    callForwardingFormat(info) {
      if (!info) {
        return { status: "-", color: "red", icon: "" };
      } else if (info.callForwarding) {
        return {
          status: this.$t("skills.manage_skill.info.schedule_enable"),
          color: "green",
          icon: "mdi-checkbox-marked-circle-outline",
        };
      } else {
        return {
          status: this.$t("skills.manage_skill.info.schedule_disabled"),
          color: "red",
          icon: "mdi-minus-circle",
        };
      }
    },
    workSchedule(info) {
      if (!info) {
        return "-";
      } else {
        var schedule = info.schedule;
        var workTime = schedule.hours.start + " - " + schedule.hours.end;
        var skillWorkSchedule = { hours: workTime };
        if (schedule.hasDays) {
          var workDays =
            schedule.days.start +
            (schedule.days.end != "-" ? " - " + schedule.days.end : "");
          skillWorkSchedule.days = workDays;
        }
        if (schedule.hasMonths) {
          var workMonth =
            schedule.months.start +
            (schedule.months.end != "-" ? " - " + schedule.months.end : "");
          skillWorkSchedule.months = workMonth;
        }
        if (schedule.hasMonthDays) {
          var workMonthDays =
            schedule.monthDays.start +
            (schedule.monthDays.end != "-"
              ? " - " + schedule.monthDays.end
              : "");
          skillWorkSchedule.monthDays = workMonthDays;
        }
        return skillWorkSchedule;
      }
    },
    showQueueConfig(skill) {
      this.$router.push({
        name: "settings-queue-config",
        params: { queue: skill.name },
      });
    },
  },
  computed: {
    ...mapGetters([
      "domain",
      "skillInfo",
      "callForwardPermission",
      "permissions",
      "getbaseURL",
      "users",
      "domainSkills",
    ]),
    filteredSkills() {
      const term = this.search.trim().toLowerCase();
      const list = this.skillsInfo || [];
      if (!term) return list;
      return list.filter((s) => {
        const title =
          (this.$i18n.locale === "ar" ? s.titles?.ar : s.titles?.en) || "";
        return (
          title.toLowerCase().includes(term) ||
          String(s.name).toLowerCase().includes(term)
        );
      });
    },
    callForwarding() {
      if (!this.skillInfo) {
        return { status: "-", color: "error", icon: "" };
      } else if (this.skillInfo.callForwarding) {
        return {
          status: "Enabled",
          color: "green",
          icon: "mdi-checkbox-marked-circle-outline",
        };
      } else {
        return { status: "Disabled", color: "red", icon: "mdi-minus-circle" };
      }
    },
    enableForwardingBtn() {
      if (!this.skillInfo) {
        return { status: "-", color: "error", icon: "" };
      } else if (!this.skillInfo.callForwarding) {
        return {
          status: "Enable Forwarding",
          color: "green",
          icon: "mdi-checkbox-marked-circle-outline",
        };
      } else {
        return {
          status: "Disable Forwarding",
          color: "red",
          icon: "mdi-minus-circle",
        };
      }
    },
  },
  watch: {
    async domain(newValue) {
      if (newValue) {
        await this.initManageSkill();
      }
    },
  },
  async mounted() {
    if (this.domain) {
      await this.GetDomainSkills();
      await this.initManageSkill();
    }
  },
};
</script>
<style scoped>
/* Center header text: the header content wrapper is a flex row, so
   text-center on the th alone doesn't align it with centered body cells. */
:deep(.p-datatable-thead th.text-center .p-datatable-column-header-content) {
  justify-content: center;
}
</style>
